import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { Table, Form } from "react-bootstrap";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import SearchBar from "../../../../components/SearchBar";
import ExportToExcel from "../../../../components/ExportToExcel";
import { Accordion, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { FaSpinner } from "react-icons/fa";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomDatePicker from "../../../../components/Custom-Datepicker";

const TneInvoiceReportConsultingContent = (data) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      updateNavbarHeading("TnE Invoice Report (Consulting & Content)")
    );
  }, []);

  const [tneData, setTneData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [emp, setEmp] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  const [activeClientKey, setActiveClientKey] = useState(null);
  const [activeProjectKeys, setActiveProjectKeys] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState({
    InvoiceDate: true,
    InvoiceNo: true,
    EmployeeName: true,
    Remarks: true,
    InvoicedAmount: true,
    TaxPercent: true,
    ExchangeRate: true,
    InvoicedAmount: true,
    PaymentTermDays: true,
    PaymentDueDate: true,
    FollowUpDate: true,
    PaymentReceivedDate: true,
    OverDueDays: true,
    OverDueAmt: true,
  });
  const columns = [
    {
      id: "InvoiceDate",
      label: "Invoice Date",
      accessor: "InvoiceDate",
      format: (val) => moment(val).format("DD-MM-YYYY"),
    },
    { id: "InvoiceNo", label: "Invoice", accessor: "InvoiceNo" },
    { id: "EmployeeName", label: "Employee", accessor: "EmployeeName" },
    { id: "Remarks", label: "Remarks", accessor: "Remarks" },
    { id: "InvoicedAmount", label: "Proforma Amt", accessor: "InvoicedAmount" },
    { id: "TaxPercent", label: "Tax %", accessor: "TaxPercent" },

    { id: "ExchangeRate", label: "Exchange Rate", accessor: "ExchangeRate" },
    { id: "InvoicedAmount", label: "Invoice Amt", accessor: "InvoicedAmount" },
    {
      id: "PaymentTermDays",
      label: "Pymt Tere Day",
      accessor: "PaymentTermDays",
    },
    {
      id: "PaymentDueDate",
      label: "Pymt.Due Date",
      accessor: "PaymentDueDate",
    },
    { id: "FollowUpDate", label: "Follow-up Date", accessor: "FollowUpDate" },
    {
      id: "PaymentReceivedDate",
      label: "Pymt.Recd Date",
      accessor: "PaymentReceivedDate",
    },
    { id: "OverDueDays", label: "OverDue", accessor: "OverDueDays" },
    { id: "OverDueAmt", label: "OverDue Amt", accessor: "OverDueAmt" },
  ];

  const toggleColumnVisibility = (columnId) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [columnId]: !prev[columnId],
    }));
  };
  const filters = {
    Employee: 0,
  };
  const [filter, setFilter] = useState(filters);
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
    Overdue: 0,
  });

  useEffect(() => {
    fetchTnEReport();
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const fetchTnEReport = async () => {
    try {
      setLoading(true); // Show spinner when starting fetch
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/10?P_FromDate&P_ToDate&P_OverDueDays`
      );

      if (response?.status === 200) {
        setTneData(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
    } finally {
      setLoading(false);
    }
  };

  // Filter data based on search term
  const filteredData = useMemo(() => {
    return tneData.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [tneData, searchTerm]);

  // Pagination logic
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Get current items for pagination
  const getCurrentItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    return filteredData.slice(startIndex, endIndex);
  };

  const currentItems = getCurrentItems();

  // Create nested structure for display from the current paginated items
  const nestedData = useMemo(() => {
    return currentItems.reduce((acc, item) => {
      if (!acc[item.ClientName]) {
        acc[item.ClientName] = {};
      }
      if (!acc[item.ClientName][item.ProjectName]) {
        acc[item.ClientName][item.ProjectName] = [];
      }
      acc[item.ClientName][item.ProjectName].push(item);
      return acc;
    }, {});
  }, [currentItems]);

  const handleClientToggle = (clientKey) => {
    if (activeClientKey === clientKey) {
      setActiveClientKey(null);
      setActiveProjectKeys((prev) => {
        const newKeys = { ...prev };
        delete newKeys[clientKey];
        return newKeys;
      });
    } else {
      setActiveClientKey(clientKey);
      // Automatically open the first project when opening a client
      setActiveProjectKeys((prev) => ({
        ...prev,
        [clientKey]: "0", // Open first project by default
      }));
    }
  };

  const handleProjectToggle = (clientKey, projectKey) => {
    setActiveProjectKeys((prev) => {
      const newKeys = { ...prev };
      // If clicking the currently active project in this client, close it
      if (newKeys[clientKey] === projectKey) {
        delete newKeys[clientKey];
      } else {
        newKeys[clientKey] = projectKey;
      }
      return newKeys;
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    const newValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
  };

  const handleGetData = async () => {
    const { fromDate, toDate, Overdue } = formData;
    setLoading(true); // Show spinner when starting fetch

    // Format dates only if they exist
    const formattedFromDate = fromDate
      ? moment(fromDate).format("YYYY-MM-DD")
      : "";
    const formattedToDate = toDate ? moment(toDate).format("YYYY-MM-DD") : "";

    const url = `${API_URL}projectmanagement/reports/10?P_FromDate=${formattedFromDate}&P_ToDate=${formattedToDate}&P_OverDueDays=${
      Overdue || ""
    }`;

    try {
      const response = await GetServiceCaller(url);
      if (response?.status === 200) {
        setTneData(response?.data?.data || []);
      }
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setLoading(false);
    }
  };

  const customIndicator = {
    display: "inline-block",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    marginBottom: "0px",
    verticalAlign: "middle",
    marginLeft: "10px",
    marginRight: "3px",
    boxShadow:
      "0 2px 9px 0 rgba(0, 0, 0, 0.18), 0 2px 7px 0 rgba(0, 0, 0, 0.15)",
    border: "solid 2px #fff",
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
        
            <div className="d-flex justify-content-between">
              <div className="d-flex">
                <div className="me-1">
                  <SearchBar
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}
                >
                  <div className="btn-group me-2">
                    <button
                      type="button"
                      className="dropdown-toggle skill-button"
                      data-bs-toggle="dropdown"
                      onClick={() => setShowDropdown(!showDropdown)}
                      aria-expanded="false"
                      id="excel-btn"
                    >
                      <i className="bi bi-funnel-fill"></i>
                    </button>
                    <ul
                      className={`dropdown-menu p-2 project-status-filter ${
                        showDropdown ? "show" : ""
                      }`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <label className="form-label">From Date</label>
                          <CustomDatePicker
                            name="fromDate"
                            className="form-control"
                            placeholderText="DD-MMM-YYYY"
                            handleChange={(e) => handleChange(e)}
                            value={formData.fromDate}
                          />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">To Date</label>
                          <CustomDatePicker
                            name="toDate"
                            className="form-control"
                            placeholderText="DD-MMM-YYYY"
                            handleChange={(e) => handleChange(e)}
                            value={formData.toDate}
                          />
                        </div>
                        <div className="col-sm-3 mt-4">
                          <label
                            htmlFor="flexSwitchCheckChecked"
                            className="form-label me-2"
                          >
                            Overdue
                          </label>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="Overdue"
                            id="flexSwitchCheckChecked"
                            checked={formData.Overdue === 1}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="text-end">
                             <button
                            className="custom-btn mx-2"
                            onClick={() => {
                              setFormData({
                                fromDate: "",
                                toDate: "",
                                Overdue: 0,
                              });
                              setShowDropdown(false);
                              fetchTnEReport();
                            }}
                          >
                            Reset
                          </button>
                          <button
                            className="custom-btn"
                            onClick={() => {
                              handleGetData();
                              setShowDropdown(false);
                            }}
                          >
                            Get Data
                          </button>
                        </div>
                      </div>
                    </ul>
                  </div>
                </OverlayTrigger>
              </div>
              <div className="d-flex justify-content-end">
                <div className="me-1">
                  <ExportToExcel data={tneData} filename="TneReport.csv" />
                </div>
                <div className="d-flex justify-content-end">
                  <div className="me-1">
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-top">Column Chooser</Tooltip>
                      }
                    >
                      <div className="btn-group me-2">
                        <button
                          type="button"
                          className="dropdown-toggle skill-button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          id="excel-btn"
                        >
                          <i className="bi bi-list"></i>
                        </button>
                        <ul className="dropdown-menu p-2">
                          <div className="row">
                            <Form.Group>
                              {columns.map((column) => (
                                <Form.Check
                                  key={column.id}
                                  type="checkbox"
                                  id={`checkbox-${column.id}`}
                                  label={column.label}
                                  checked={columnVisibility[column.id]}
                                  onChange={() =>
                                    toggleColumnVisibility(column.id)
                                  }
                                />
                              ))}
                            </Form.Group>
                          </div>
                        </ul>
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-1 d-flex align-items-center">
              <p style={{ ...customIndicator, background: "#bad893" }}></p>
              <span className="me-3">FixedBid</span>
              <p style={{ ...customIndicator, background: "#ffe4a4" }}></p>
              <span>Consolidated</span>
            </div>
              <div className="table-responsive">
            <Table bordered striped hover>
              <thead id="thcolor" className="text-center">
                <tr>
                  <th>##</th>
                  {columnVisibility.InvoiceDate && <th>Inv. Date</th>}
                  {columnVisibility.InvoiceNo && <th>Invoice</th>}
                  {columnVisibility.EmployeeName && <th>Emp. Name</th>}
                  {columnVisibility.Remarks && <th>Remarks</th>}
                  {columnVisibility.InvoicedAmount && <th>Proforma Amt</th>}
                  {columnVisibility.TaxPercent && <th>Tax %</th>}
                  {columnVisibility.ExchangeRate && <th>Exchange Rate</th>}
                  {columnVisibility.InvoicedAmount && <th>Invoice Amt</th>}
                  {columnVisibility.PaymentTermDays && <th>Pymt.Term Days</th>}
                  {columnVisibility.PaymentDueDate && <th>Pymt Due Date</th>}
                  {columnVisibility.FollowUpDate && <th>Follow-up Date</th>}
                  {columnVisibility.PaymentReceivedDate && (
                    <th>Pymt Recd Date</th>
                  )}
                  {columnVisibility.OverDueDays && <th>Overdue</th>}
                  {columnVisibility.overdueamt && <th>Overdue Amt</th>}
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={21} className="text-center py-4">
                      <div className="d-flex justify-content-center">
                        <FaSpinner class="spinner" />
                      </div>
                      <div className="text-muted mt-2">Loading</div>
                    </td>
                  </tr>
                ) : Object.keys(nestedData).length === 0 ? (
                  <tr>
                    <td colSpan={21} className="text-center text-muted py-3">
                      No Record Found
                    </td>
                  </tr>
                ) : (
                  Object.entries(nestedData).map(
                    ([clientName, projects], clientIndex) => {
                      const clientKey = clientIndex.toString();
                      return (
                        <tr key={clientKey}>
                          <td
                            colSpan={21}
                            className="px-0"
                            style={{ padding: "0px !important" }}
                          >
                            <Accordion activeKey={activeClientKey}>
                              <Accordion.Item eventKey={clientKey}>
                                <Accordion.Header
                                  onClick={() => handleClientToggle(clientKey)}
                                  className="p-0 m-0"
                                >
                                  <div className="flex-grow-1 text-dark fw-bold">
                                    {clientName}
                                  </div>
                                  <span className="me-2 accordion_icon">
                                    <FontAwesomeIcon
                                      icon={
                                        activeClientKey === clientKey
                                          ? faMinus
                                          : faPlus
                                      }
                                    />
                                  </span>
                                </Accordion.Header>

                                <Accordion.Body className="p-0">
                                  <Accordion
                                    activeKey={
                                      activeProjectKeys[clientKey] || null
                                    }
                                  >
                                    {Object.entries(projects).map(
                                      ([projectName, items], projectIndex) => {
                                        const projectKey =
                                          projectIndex.toString();
                                        return (
                                          <Accordion.Item
                                            eventKey={projectKey}
                                            key={projectKey}
                                          >
                                            <Accordion.Header
                                              onClick={() =>
                                                handleProjectToggle(
                                                  clientKey,
                                                  projectKey
                                                )
                                              }
                                            >
                                              <div className="flex-grow-1 px-8 text-dark">
                                                {projectName}
                                                <span className="text-muted">
                                                  {" "}
                                                  (SOW/PO/SO{" "}
                                                  {items[0]
                                                    ?.ProjectInvoiceDetailNumber ||
                                                    "N/A"}
                                                  )
                                                </span>
                                              </div>
                                              <span className="me-2 accordion_icon">
                                                <FontAwesomeIcon
                                                  icon={
                                                    activeProjectKeys[
                                                      clientKey
                                                    ] === projectKey
                                                      ? faMinus
                                                      : faPlus
                                                  }
                                                />
                                              </span>
                                            </Accordion.Header>

                                            <Accordion.Body>
                                              <Table bordered striped hover>
                                                <tbody>
                                                  {items.map(
                                                    (data, subIndex) => (
                                                      <tr
                                                        key={subIndex}
                                                        className="border"
                                                      >
                                                        <td
                                                          style={{
                                                            width: "60px",
                                                          }}
                                                        ></td>
                                                        {columnVisibility.InvoiceDate && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.InvoiceDate ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.InvoiceNo && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.InvoiceNo ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.EmployeeName && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.EmployeeName ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.Remarks && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.Remarks || ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.InvoicedAmount && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.InvoicedAmount ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.TaxPercent && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.TaxPercent ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.ExchangeRate && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.ExchangeRate ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.InvoicedAmount && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.InvoicedAmount ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.PaymentTermDays && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.PaymentTermDays ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.PaymentDueDate && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.PaymentDueDate ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.FollowUpDate && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.FollowUpDate ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.PaymentReceivedDate && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.PaymentReceivedDate ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.OverDueDays && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.OverDueDays ||
                                                              ""}
                                                          </td>
                                                        )}
                                                        {columnVisibility.OverDueAmt && (
                                                          <td
                                                            style={{
                                                              width: "100px",
                                                            }}
                                                          >
                                                            {data.OverDueAmt ||
                                                              ""}
                                                          </td>
                                                        )}
                                                      </tr>
                                                    )
                                                  )}
                                                </tbody>
                                              </Table>
                                            </Accordion.Body>
                                          </Accordion.Item>
                                        );
                                      }
                                    )}
                                  </Accordion>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </td>
                        </tr>
                      );
                    }
                  )
                )}
              </tbody>
            </Table>

            <div className="d-flex justify-content-between mb-3">
              <div>
                <span className="d-flex align-items-center">
                  Showing {(currentPage - 1) * itemsPerPage + 1} -{" "}
                  {Math.min(currentPage * itemsPerPage, filteredData.length)} of{" "}
                  {filteredData.length} <span className="ms-1">results</span>
                  <select
                    value={itemsPerPage}
                    onChange={(e) => {
                      const newItemsPerPage = Number(e.target.value);
                      setItemsPerPage(newItemsPerPage);
                      setCurrentPage(1); // Reset to first page when changing items per page
                    }}
                    className="mx-2 form-select-sm"
                  >
                    {recordsPerPageOption.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </span>
              </div>
              <div>
                <Pagination
                  itemsPerPage={itemsPerPage}
                  totalItems={totalItems}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TneInvoiceReportConsultingContent;
